import { ref } from 'vue'
import type { UseDrawingReturn } from '~/composables/useEditPdfDrawing'

// **
//   这个文件，主要是协助管理，区域编辑，做全局状态管理使用。
// *//
interface DrawingInstance {
  enable: () => void
  disable: () => void
  setDrawingMode: (mode:any,options?:any) => void
  exportData: () => void
  exportAllData : () => void
  setCanvasZIndex : (numStr:any) => void
  importDataSetCanvasUiEndData : (canvasData:any,index:any) => void
  updateShapeIgnoreType : (modeType:string ,index: number, ignoreType: string) => void
  instance: UseDrawingReturn
}

type DrawingChangeEvent = 'page' | 'line' | 'rectangle'
type DrawingChangeListener = (id: string, data: any,eventType: DrawingChangeEvent) => void
const listeners = new Set<DrawingChangeListener>()

const drawingsMap = ref<Record<string, DrawingInstance>>({})

export function registerDrawing(id: string, drawing: UseDrawingReturn) {
  
  const drawingInstance = {
    enable: () => drawing.toggleDrawing(true),
    disable: () => drawing.toggleDrawing(false),
    setDrawingMode: (mode: any, options?: any) => {
      drawing.setDrawingMode(mode, options)

      // let eventType: DrawingChangeEvent
      // switch (mode) {
      //   case DrawingMode.PageFlag:
      //     eventType = 'page'
      //     break
      //   case DrawingMode.Line:
      //     eventType = 'line'
      //     break
      //   case DrawingMode.Rectangle:
      //     eventType = 'rectangle'
      //     break
      //   default:
      //     eventType = 'page' // 默认值或可扩展其他类型
      // }
      // notifyListeners(id, drawing.exportAllData(),eventType)
    },
    exportData: () => drawing.exportData(),
    exportAllData: () => drawing.exportAllData(),
    setCanvasZIndex: (numStr: any) => drawing.setCanvasZIndex(numStr),
    importDataSetCanvasUiEndData: (canvasData: any,index:any) => {
     
      drawing.importDataSetCanvasUiEndData(canvasData,index)
    },
    updateShapeIgnoreType: (modeType:string ,index: number, ignoreType: string) => drawing.updateShapeIgnoreType(modeType, index, ignoreType),
    instance: drawing
  }
  
  if (!Object.hasOwn(drawingsMap.value, id)) {
    drawingsMap.value = {
      ...drawingsMap.value,
      [id]: drawingInstance
    }
  }
	// console.log(drawingsMap.value,'drawingsMap.value')
  // 绑定图形变化监听器
  drawing.onDrawingChange((eventType:any) => {
    console.log('drawing change, 监听数据响应变化', eventType)
    notifyListeners(id, drawing.exportAllData(),eventType)
  })
}


export function getDrawing(id: string): DrawingInstance | undefined {
  return drawingsMap.value[id]
}

export function getAllDrawings() {
  return drawingsMap.value
}
export function notifyListeners(id: string, data: any,eventType: DrawingChangeEvent) {
  listeners.forEach(listener => listener(id, data,eventType))
}
export function subscribe(listener: DrawingChangeListener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  };
}

export function clearDrawings() {
  const map = drawingsMap.value
	if (!map) return
  Object.keys(map).forEach(key => {
    delete map[key]
  })
}
